<template>
    <div v-if="isVisible" class="modal-overlay" @keydown.esc="$emit('close')">
        <div class="modal-content">
            <div class="modal-header">
              <h2>Recuperar Venta</h2>
              <button class="modal-close-x" @click="$emit('close')">✕</button>
            </div>

            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>No. Venta</th>
                            <th>Cliente</th>
                            <!-- <th>Observaciones</th> -->
                            <th>Fecha y Hora</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(venta, index) in returnVentas" :key="index" @dblclick="handleVentaSelect(venta)"
                            class="venta-row">
                            <td>{{ index+1 }}</td>
                            <td>{{ venta.nombre_cliente }}</td>
                            <td>{{ formatearFecha(venta.created_at) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="button-group">
                <button @click="$emit('close')" class="btn-cancel">Cerrar</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecuperarVentaModal',
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        ventas: {
            type: Array,
            required: true
        }
    },

    computed: {
        returnVentas(){
            return this.ventas;
        }
    },

    mounted() {
        this._escHandler = (e) => {
            if (e.key === 'Escape' && this.isVisible) {
                e.stopPropagation();
                this.$emit('close');
            }
        };
        window.addEventListener('keydown', this._escHandler, true);
    },

    beforeUnmount() {
        window.removeEventListener('keydown', this._escHandler, true);
    },

    methods: {
        handleVentaSelect(venta) {
            this.$emit('venta-selected', venta);
            this.$emit('close');
        },
        formatearFecha(fecha) {
            if (!fecha) return '—';
            const d = new Date(fecha);
            return isNaN(d.getTime()) ? '—' : d.toLocaleString('es-HN');
        }
    }
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 800px;
    max-width: 90%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

.modal-header {
    display: flex;
    align-items: center;
    margin-bottom: 0;
}

.modal-header h2 {
    flex: 1;
    margin: 0;
}

.table-container {
    overflow-y: auto;
    margin: 15px 0;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    background-color: #f5f5f5;
    font-weight: 600;
}

.venta-row {
    cursor: pointer;
}

.venta-row:hover {
    background-color: #f5f5f5;
}

.button-group {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.btn-cancel {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background: #ef4444;
    color: #fff;
    cursor: pointer;
}

.btn-cancel:hover {
    background: #dc2626 !important;
}

/* Dark mode */
.dark .modal-content {
    background: #1e1e1e;
    color: #e5e7eb;
}

.dark .modal-header h2 { color: #c09d62; }

.dark th {
    background-color: #252525;
    color: #c09d62;
    border-bottom-color: #3a3a3a;
}

.dark td {
    border-bottom-color: #2d2d2d;
    color: #d1d5db;
}

.dark .venta-row:hover { background-color: #2a2a2a; }

.dark .modal-close-x {
    background: transparent;
    color: #9ca3af;
    border: none;
    cursor: pointer;
}
.dark .modal-close-x:hover { color: #e5e7eb; }
</style>

<style>
/* Overrides globales — otros modales definen html.dark .modal-content button en verde */
.btn-cancel { background-color: #ef4444 !important; color: #fff !important; }
.btn-cancel:hover { background-color: #dc2626 !important; }
html.dark .modal-content .btn-cancel { background-color: #ef4444 !important; color: #fff !important; }
html.dark .modal-content .btn-cancel:hover { background-color: #dc2626 !important; }
</style>